export default "__VITE_ASSET__22164091__"